// Remembers whether the cart notes <details> is open so it survives cart re-renders
let cartNotesOpen = false;

document.addEventListener('toggle', (event) => {
  if (event.target.matches?.('[data-cart-notes]')) {
    cartNotesOpen = event.target.open;
  }
}, true);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('input', (event) => {
      const textarea = event.target;
      const remainingCount = this.querySelector('[data-cart-notes-count]');
      if (!remainingCount || textarea.maxLength < 0) return;

      remainingCount.textContent = Math.max(textarea.maxLength - textarea.value.length, 0);
    });

    this.addEventListener(
      'input',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...{
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        }, ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER)
    );
  }

  connectedCallback() {
    const details = this.closest('[data-cart-notes]');
    if (!details || !cartNotesOpen) return;

    details.open = true;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
  }
});
